module.exports = __webpack_public_path__ + "80f34459277aefe7d0fba2ed60d3363a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/valorant/logo.jpg
// module id = 1045
// module chunks = 0